export interface Config {
    [key: string]: any;
    default_language: 'sv-SE' | 'en-US';
}
let default_config: Config = {
    api: {
        sso: {
            api_uri:
                process.env.REACT_APP_SSO_API_URI ||
                'https://sso.test.allbin.se',
        },
    },
    dashboard: {
        url:
            process.env.REACT_APP_DASHBOARD_URL ||
            'https://dashboard.allbin.se',
    },
    slack: {
        webhook_uri:
            process.env.REACT_APP_SLACK_WEBHOOK_URI ||
            'https://hooks.slack.com/services/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',
    },
    production: process.env.NODE_ENV === 'production',

    send_errors_to_slack_in_dev: false,

    default_language: 'sv-SE',

    update_check_timer: 600000, //ms
};

export default default_config;



// WEBPACK FOOTER //
// ./src/default_config.ts